import { createAction, props } from '@ngrx/store';

import {
    ICallableAssistance,
    ICallableOptionsAssistance,
    IResultGetOptionsAssistance,
    IResultSaveAssistance,
} from '../../shared/models/Assistance';

/*
 * Consulta opciones para el centro de asistencia
 */
export const getOptionsAssistance = createAction(
    '[Assistance] Get Options Assistance',
    props<ICallableOptionsAssistance>()
);

export const successGetOptionsAssistance = createAction(
    '[Assistance] SuccessGetOptionsAssistance',
    props<IResultGetOptionsAssistance>()
);

export const errorGetOptionsAssistance = createAction(
    '[Assistance] Error Get OptionsAssistance',
    props<{ payload: Error }>()
);


/*
 * Almacena solicitud de asistencia
 */
export const saveAssistance = createAction(
    '[Assistance] Save Assistance',
    props<ICallableAssistance>()
);

export const successSaveAssistance = createAction(
    '[Assistance] Success Save Assistance',
    props<IResultSaveAssistance>()
);

export const errorSaveAssistance = createAction(
    '[Assistance] Error Save Assistance',
    props<{ payload: Error }>()
);

export const clearSaveAssistance = createAction('[Assistance] Clear Save Assistance');